import { ExtendedHistoriaResponse } from './extended-historia-response';
import { OsobaOrganizacieZaradeniaZiadost } from './osoba-organizacie-zaradenia-ziadost';

/**
 * 
 * @export
 * @interface OsobaOrganizacieZaradenie
 */
export interface OsobaOrganizacieZaradenie {
    /**
     * 
     * @type {number}
     * @memberof OsobaOrganizacieZaradenie
     */
    'id'?: number;
    /**
     * 
     * @type {ExtendedHistoriaResponse}
     * @memberof OsobaOrganizacieZaradenie
     */
    'meta'?: ExtendedHistoriaResponse;
    /**
     * 
     * @type {string}
     * @memberof OsobaOrganizacieZaradenie
     */
    'zaradenie'?: OsobaOrganizacieZaradenieZaradenieEnum;
    /**
     * 
     * @type {OsobaOrganizacieZaradeniaZiadost}
     * @memberof OsobaOrganizacieZaradenie
     */
    'ziadost'?: OsobaOrganizacieZaradeniaZiadost;
}

export const OsobaOrganizacieZaradenieZaradenieEnum = {
    KontaktnaOsoba: 'KONTAKTNA_OSOBA',
    KonecnyUzivatelVyhod: 'KONECNY_UZIVATEL_VYHOD',
    FyzickaOsobaPodnikatel: 'FYZICKA_OSOBA_PODNIKATEL',
    Statutar: 'STATUTAR',
    Zamestnanec: 'ZAMESTNANEC',
    OpravnenaOsoba: 'OPRAVNENA_OSOBA'
} as const;

export type OsobaOrganizacieZaradenieZaradenieEnum = typeof OsobaOrganizacieZaradenieZaradenieEnum[keyof typeof OsobaOrganizacieZaradenieZaradenieEnum];


